module.exports = __webpack_public_path__ + "static/media/logo-eprice--squared.3e2ca8e9.png";